import React, { useEffect, useState } from "react"
import { useSelector, useDispatch } from "react-redux"

import { CcLibraryHeading } from "server/models"
import { IDLE, PENDING } from "const"
import { StateType } from "client/utils"
import {
    StoreType,
    LoadCcLibraryHeadingById,
    setCcLibraryHeadingEdit,
    setCcLibraryHeadingReloadEdit,
    setCcLibraryHeadingAvailableParents,
    initCcLibraryHeading,
} from "client/store"
import {
    Container,
    PageHeader,
    PageTitle,
    PageContent,
    Loader,
    TableGroupedIds,
} from "client/components"

import NotFound from "client/parts/notFound"
import Form from "./form"


interface CcLibraryHeadingProps {
    headingId: number
    parentId: number
}

const HeadingEdit = ({
    headingId,
    parentId,
}: CcLibraryHeadingProps) => {
    const nested = useSelector((state: StoreType) => state.ccLibraryItem.itemGroupedIds)
    const heading = useSelector((state: StoreType) => state.ccLibraryHeading.headingEdit)
    const headingList = useSelector((state: StoreType) => state.ccLibraryHeading.headingList)
    const reloadEdit = useSelector((state: StoreType) => state.ccLibraryHeading.reloadEdit)
    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const [loadState, setLoadState] = useState<StateType>(IDLE)

    const reload = () => {
        dispatch(setCcLibraryHeadingReloadEdit(false))
        setTimeout(() => {
            dispatch(setCcLibraryHeadingReloadEdit(true))
        }, 0)
    }

    useEffect(() => {
        if (headingId === 0) {
            dispatch(setCcLibraryHeadingEdit(initCcLibraryHeading))
            reload()
        } else {
            setLoadState(PENDING)
            LoadCcLibraryHeadingById(headingId).then((res) => {
                dispatch(setCcLibraryHeadingEdit(res))
                setLoadState(IDLE)
                reload()
            })
        }
    }, [])

    useEffect(() => {
        const availableHeadings: CcLibraryHeading[] = []
        const addHeadings = (rows: readonly TableGroupedIds[]) => {
            rows.forEach((row) => {
                if (row.groupId !== heading.id) {
                    availableHeadings.push(headingList[row.groupId])
                    addHeadings(row.nestedGroupedIds)
                }
            })
        }
        addHeadings(nested.nestedGroupedIds)
        dispatch(setCcLibraryHeadingAvailableParents(availableHeadings))
    }, [nested, headingList, heading])

    const parent = headingList[parentId] || null
    if (!heading) return <NotFound />
    return (
        <Container>
            <PageHeader>
                <PageTitle>
                    {heading.id ? `${lang.editParagraph} # ${heading.id}` : lang.addParagraph}
                </PageTitle>
            </PageHeader>
            <PageContent>
                {loadState === PENDING && <Loader />}
                {
                    !reloadEdit
                    && <Form heading={heading} parent={parent} />
                }
                {
                    reloadEdit
                    && <Form heading={heading} parent={parent} />
                }
            </PageContent>
        </Container>
    )
}
export default HeadingEdit
